export { default } from '../[...param]';
